<template>
  <!--form for invoice object-->
  <div v-if="loading">
    Loading invoice form...
  </div>
  <div v-else class="container no-print">
    <!--div class="debug">
            <p>invoiceId prop = {{ invoiceId }}</p>
            <p>datePaid = {{ mInvoice.datePaid }}</p>
            <p>isPaid = {{ isPaid }}</p>
        </div>-->

    <MyForm :title="'Invoice Form'">
      <template v-slot:fields>
        <FormItem>
          <div>
            <CheckboxGroup :options="checkboxOptions" v-model:checked="isPaid"></CheckboxGroup>
            <FormDatepicker
              v-if="isPaid"
              v-model="mInvoice.datePaid"
              :name="'date paid:'"
            ></FormDatepicker>
          </div>
        </FormItem>

        <!--Form-input v-model="props.index" :readonly=true :disabled=true :name="'index:'"></Form-input-->
         <!--Form-input v-model="mInvoice.id" :readonly=true :disabled=true :name="'id:'"></Form-input-->
          <!--     
                <Form-input v-model="mInvoice.created_by" :readonly=true :disabled=true
                    :name="'created by:'"></Form-input>
                <Form-input v-model="mInvoice.created_on" :readonly=true :disabled=true
                    :name="'created on:'"></Form-input>
                <Form-input v-model="mInvoice.modified_on" :readonly=true :disabled=true
                    :name="'modified on:'"></Form-input>
                <Form-input v-model="mInvoice.projectId" :readonly=true :disabled=true
                    :name="'project id:'"></Form-input> -->
        <UserSelect
          v-model:selected="mInvoice.owner_id"
          :name="'Owner:'"
          :role="'owner'"
          :includeArchived="true"
        ></UserSelect>

        <UserSelect
          v-model:selected="mInvoice.engineer_id"
          :name="'Engineer:'"
          :role="'engineer'"
          :includeArchived="true"
        ></UserSelect>
<!--
        <Form-input
          v-model="mInvoice.address"
          :readonly="true"
          :disabled="true"
          :name="'address:'"
        ></Form-input>
        <Form-input
          v-model="mInvoice.province"
          :readonly="true"
          :disabled="true"
          :name="'province:'"
        ></Form-input>
        <Form-input
          v-model="mInvoice.taxRate"
          :readonly="true"
          :disabled="true"
          :name="'tax rate:'"
        ></Form-input>
      -->
        <!--CustomerSelect v-model:selected="mInvoice.customerId"></CustomerSelect-->
        <CustomerListbox v-model:customer="mInvoice.customer"></CustomerListbox>
        <FormSelect
          :name="'Job Rate:'"
          :options="jobRateOptions"
          :displayOptions="jobRateDisplayOptions"
          v-model:selected="jobRate"
        ></FormSelect>

        <LineItemsTable
          :taxRate="mInvoice.taxRate"
          v-model:netValue="mInvoice.value_total"
          v-model:netTax="mInvoice.tax_total"
          v-model:lineItems="mInvoice.lineItems"
          v-model:jobRate="jobRate.value"
        ></LineItemsTable>
      </template>

      <template v-slot:buttons>
        <div class="form-btns">
          <!--FormBtn :name="'Submit'" @clicked="emits('submitForm', 'mInvoice')"></FormBtn-->
          <FormBtn :name="'Save Changes'" @clicked="submitForm"></FormBtn>
          <!--FormBtn :name="'Revert'" @clicked="emits('revertForm', 'mInvoice')"></FormBtn-->
          <FormBtn :name="'Revert'" @clicked="revertForm"></FormBtn>
          <FormBtn :name="'View Invoice'" @clicked="previewInvoice"></FormBtn>
          <FormBtn :name="'Delete Invoice'" @clicked="deleteInvoice" :class="'red'"></FormBtn>
          <!--button type="button" class="btn btn-primary" @click="emits('submitForm','mInvoice')">Submit</button>
                    <button type="button" class="btn btn-warning" @click="emits('revertForm')">Revert Changes</button>-->
        </div>
      </template>
    </MyForm>
    <!--Prompt :id="'inv-1' ":name="invoices" :key='promptkey' @confirmed="deleteInvoice" @cancelled="cancelDelete"></Prompt-->

    <div class="debug">
      <p>Within Invoice-form.vue:</p>
      <p>reactive mInvoice:</p>
      <p v-for="(value, key) in mInvoice" :key="key">{{ key }}: {{ value }}</p>
    </div>
  </div>

  <!--modal div for invoice printing-->
  <div id="print-modal" class="modal">
    <div class="modal-content">
      <div class="modal-header no-print">
        <div class="form-btns">
          <FormBtn :name="'&times'" @clicked="closeModal"></FormBtn>
          <FormBtn :name="'File This Invoice'" @clicked="print"></FormBtn>
          <p>Filename : {{ invFileName }}</p>
        </div>
      </div>
      <div id="print-div" class="modal-body">
        <SMPInvoice v-if="!loading"
          :invoiceId="mInvoice.id"
          :customer="mInvoice.customer.invoiceName"
          :lineItems="mInvoice.lineItems"
          :address="mInvoice.address"
          :taxRate="mInvoice.taxRate"
          :tax="tax"
          v-model:taxTotal="mInvoice.tax_total"
          v-model:valueTotal="mInvoice.value_total"
          :date="mInvoice?.modified_on"
          :initials="ownerInitials"
        >
        </SMPInvoice>
      </div>
    </div>
  </div>

 
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import LineItemsTable from './Lineitems-table.vue'
import {
  MyForm,
  FormInput,
  FormSelect,
  FormDatepicker,
  FormBtn,
  CheckboxGroup,
  FormItem,
  UserSelect
} from '@/components/form'
import type { Invoice } from '@/types/types'
//import CustomerSelect from '@/components/Customer-select.vue'
import CustomerListbox from '@/components/Customer-listbox.vue';
import {
  useProjectStore,
  useInvoiceStore,
  useAlertStore,
  useUserStore,
  useCustomerStore,
  usePromptStore
} from '@/stores'
import { jsPDF } from 'jspdf'
import { TaxOptions, customerSchema, lineItemSchema } from '@/types/types'
//import { getInitials } from '@/stores/user'
import Prompt from '@/components/Prompt.vue'
import SMPInvoice from '@/views/projects/invoices/SMP-invoice.vue'
import router from '@/router'
import axios from '@/libs/axios'
import { useRoute } from 'vue-router'
import { useCurrentProject } from '@/composables/Current-project';
import { useInvoicePrinter } from '@/composables/Invoice-printer';
import { usePdfDownloader } from '@/composables/pdf-downloader';
import { onBeforeMount } from 'vue';

//const promptkey = ref('invoicePromptKey');
//const { printWithHtml2Canvas, printWithJspdf } = useInvoicePrinter();
const userStore = useUserStore();
const route = useRoute();
const invoiceId = computed(()=>{
  return route.params.invoiceId;
})
//const prompt = usePromptStore();
function cancelDelete(){
  console.log("invoice-form delete cancelled from prompt...");
}

/*const props = defineProps({
  invoiceId: { type: String, required: true }
  //invoiceNo: { type: String, required: true }
})*/
const invoices = useInvoiceStore()
const alert = useAlertStore()
const projects = useProjectStore()
const { currentProject } = useCurrentProject();
/*const loading = computed(()=>{
  return invoices.loading.value;
})*/
/*const props = defineProps<{
  invoiceId: string
}>()*/
//const province = currentProject.value.province
//const tax = TaxOptions[province]
const tax = computed(() =>{
  return TaxOptions[currentProject.value.province];
})
//import * as yup from 'yup'
const checkboxOptions = ref(['paid?'])
const isPaid = ref(false)

const jobRateOptions = [
  { value: 'rate1', name: '1. Residential Rate' },
  { value: 'rate2', name: '2. Commercial Rate' }
]
const jobRateDisplayOptions = jobRateOptions.map((item) => {
  return item.name
})
const jobRate = ref(jobRateOptions[0])
//const jobRate = defineModel('jobRate',{default: '1. Residential Rate'});

//const projectInvoices = await invoices.getProjectInvoices(currentProject.value.id);
//const projects = useProjectStore();
//const project = await projects.currentProject;
//const invArr = project.invoices;
//try computed from route
const loading = ref<Boolean>(true);
const mInvoice = ref<Invoice>(null)
//this an async component wrapped in suspense:
loading.value = true;
mInvoice.value = await invoices.getById(invoiceId.value); //todo get from route param
loading.value = false;
/*
onBeforeMount(async ()=>{
  console.log("invoiceId = " + invoiceId.value)
  mInvoice.value = await invoices.getById(invoiceId.value)
  console.log("mInvoice = " + JSON.stringify(mInvoice.value));
  loading.value = false;
})*/

/*
const mInvoice = computed(()=>{
  console.log("invoice form mInvoice computed(), route params invoiceID has changed...");
  return invoices.getById(route.params.invoiceId)
})*/

async function confirmDelete() {
  console.log('invoice form promptDelete()...')
  prompt.promptUser({
    header: 'Delete Invoice?',
    body: 'This will permanently delete this invoice from the database, continue? (if pdf is filed, it will remain)'
  })
}

const ownerInitials = computed(() => {
  const userStore = useUserStore();
  //return userStore.getInitials(mInvoice.value.owner)
  const owner = userStore.getById(mInvoice.value.owner_id);
  return owner.initials;
})

const engInitials = computed(() => {
  const userStore = useUserStore();
  //return userStore.getInitials(mInvoice.value.owner)
  const eng = userStore.getById(mInvoice.value.engineer_id);
  return eng.initials;
})


function cleanHyphens(string){
  return string.replaceAll('-', ' ');
}

const invFileName = computed(() =>{
  const i = mInvoice.value;
  //const ownerInitials = "RR";
  //const engInitials = "AA";
  //const engEmail = currentProject.value.engineer;
  //const userStore = useUserStore();
  const ownerInitials = userStore.getById(i.owner_id).initials;
  const engInitials = userStore.getById(i.engineer_id).initials;
  //const engInitials = userStore.getInitials(engEmail);
  let filename = 'error';
  try{
    filename =  'INVOICE' +
      i.id +
      '-' +
      i.customer.name +
      '-' +
      i.province +
      '-' +
      cleanHyphens(i.address) +
      '-' +
      cleanHyphens(i.customer.companyName) +
      '-' +
      ownerInitials +
      '-' +
      engInitials +
      '-' +
      i.value_total
  //const filename = "filename 1 testing";
  }catch(error){
    console.log("error computing invFileName : " + error)
  }
      console.log("invoicne fileName = " + filename)
  
  return filename;
})

/**
 * update the invoice, validate with yup first
 * TODO is router push necessary?
 */
async function submitForm() {
  console.log('invoice form submitted...')
  //try form validation
  if (!isPaid.value) {
    mInvoice.value.datePaid = null
  }
  mInvoice.value.customer_id = mInvoice.value.customer.id;
  await invoices.updateInvoice(mInvoice.value)
  
}

/**
 * revert the form to db value
 * TODO router.push doesnt seem to reload the 'page'
 */
async function revertForm() {
  console.log('invoice form reverted...')
  router.push(`/projects/${mInvoice.value.projectId}/invoices/${invoiceId.value}`);
  //await fetchInvoice()
}

/**
 * delete the invoice from db
 */
async function deleteInvoice() {
  //prompt.close();
  console.log('invoice form delete called...')
  //console.log("....doing nothing....");
  const projId = mInvoice.value.projectId;
  await invoices.deleteInvoice(mInvoice.value.id)
  router.push({ name: 'project_invoices', params: { projectId: projId } })

}

/**
 * preview invoice for printing
 */
async function previewInvoice() {
  console.log('Invoice-form.previewInvoice()...')
  const modal = document.getElementById('print-modal')
  modal.style.display = 'block'
}

/**
 * close modal preview
 */
function closeModal() {
  console.log('Invoice-form.closeModal()...')
  const modal = document.getElementById('print-modal')
  modal.style.display = 'none'
}

/**
 * print the invoice ie: make modal visible
 * send the completed html as a blob to backend/api
 * api will pdf and upload to google drive folder
 */
async function print() {
  console.log('Invoice-form.print()...')
  alert.success('Filing invoice on backend...');
  let doc = new jsPDF({
    orientation: 'portrait',
    unit: 'px',
    format: 'letter',
    hotfixes: ['px_scaling']
  })
  let source = document.getElementById('print-div') //.innerHTML;
  let fd = new FormData()
  //the api files the invoice in a subfolder named for the invoice year, set in the db when the invoice is created
  fd.append('year', String(mInvoice.value.year))
  let pdfBlob: Blob
  let filename: string
  await doc.html(source, {
    callback: (pdf) => {
      //var iframe = document.createElement('iframe');
      //iframe.setAttribute('style', 'position:absolute;top:0;right:0;height:100%; width:600px');
      //document.body.appendChild(iframe);
      // iframe.src = pdf.output('datauristring');
      pdfBlob = new Blob([pdf.output('blob')], { type: 'application/pdf' })
      filename = invFileName.value
      fd.append('invoice', pdfBlob, filename)
    }
  })

  try {
    const folderId = currentProject.value.folderId
    console.log('...Invoice form print, folderId = ' + folderId)
    const response = await axios.post(`/gdrive/invoice/${folderId}`, fd, {
      headers: {
        'Content-Type': `multipart/form-data`
      }
    })
    //const response = await axios.get('http://127.0.0.1:3000/projects');
    console.log('response from backend is:...')
    console.log(response)
    closeModal()
    alert.success('Invoice PDF has been created and filed.')
    const { downloadPdf } = usePdfDownloader();
    downloadPdf(pdfBlob, filename)
    //write INVOICED status
    await projects.addStatus(currentProject.value, 'INVOICED');
     setTimeout(() => {
      alert.clear()
    }, 2000)
  } catch (error) {
    console.error(error)
    //show the api's reason when it gives one, eg: the invoice year is missing
    alert.error(error.response?.data?.message ?? error)
  }
}

/**
 * download the pdf in browser
 *
function downloadPdf(pdfBlob: Blob, filename: string) {
  console.log('invoice form download PDF...')

  //download the blob data
  // const CSVFile = new Blob([csvData2], { type: 'text/csv' });
  // Create to temporary link to initiate
  // download process
  let temp_link = document.createElement('a')

  // Download csv file
  temp_link.download = filename
  let url = window.URL.createObjectURL(pdfBlob)
  temp_link.href = url

  // This link should not be displayed
  temp_link.style.display = 'none'
  document.body.appendChild(temp_link)

  // Automatically click the link to trigger download
  temp_link.click()
  document.body.removeChild(temp_link)
}*/

/**
 * compute the net (total) value of invoice entries
 */
const netValue = computed(() => {
  console.log('Invoice-form.netValue computing..')
  let total = 0
  try {
    mInvoice.value.lineItems.items.forEach((entry) => {
      total += Number(entry.value)
    })
  } catch (err) {
    console.log('...lineItems has no values...')
  }
  return formatDollars(total)
})

/**
 * compute the net (total) value of tax
 */
const netTax = computed(() => {
  console.log('Invoice-form.netValue computing..')
  return formatDollars(netValue.value * mInvoice.value.taxRate)
})

/**
 * format the number into 2 decimal places max
 * @param {Number} num
 */
function formatDollars(num: number) {
  return Math.round(num * 100) / 100
}
</script>

<style lang="css" scoped>
@media print {
  /*
    .modal-header {
        display: none;
    }
    .container {
        display: none;
    }

    #print-div{
      
      display: block;
    }*/
}

/*
div.form-button-group {
    display: flex;
    flex-direction: row-reverse;
    gap: 1rem;

}*/
.form-btns,
.modal-header {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}

/* The Modal (background) */
.modal {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

/* Modal Content/Box */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  /* 15% from the top and centered */
  /*padding: 20px;*/
  /*border: 1px solid #888;*/
  width: 8.5in;
  /* Could be more or less, depending on screen size */
  /*height: 11in;*/
}

/* Modal Header / button s */
.modal-header {
  height: 4rem;
  /*width: 8.5in;*/
  width: 100%;
  background-color: azure;
  border: 1px solid blue;
  padding-right: 2rem;
  padding-top: auto;
}

/* Modal body / the page to print */
.modal-body {
  /*height: 8.5in;
    width: 11in;*/
  /*margin: 1rem;*/
  padding: 1rem;
  width: auto;
  height: 10in;
}
</style>
